// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  height: 100%;
  width: 100%;
  position: fixed;
}

#root {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

/* Для элементов, где нужен скроллинг содержимого */
.scrollable-content {
  overflow-y: auto;
  height: 100%;
} `, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["html, body {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n  position: fixed;\n}\n\n#root {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n/* Для элементов, где нужен скроллинг содержимого */\n.scrollable-content {\n  overflow-y: auto;\n  height: 100%;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
